export default function useRemoveFormSerial(Serializer) {
  (Serializer.findProperty('survey', 'multipleSubmissions') || {}).visible = false;
  (Serializer.findProperty('survey', 'submissionLimit') || {}).visible = false;
  (Serializer.findProperty('survey', 'submissionPrompt') || {}).visible = false;
  (Serializer.findProperty('survey', 'submissionPastResults') || {}).visible = false;
  (Serializer.findProperty('survey', 'completionMessage') || {}).visible = false;
}
